import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useComponentSize } from '@carnica/utils/hooks';
import { useEffect, useMemo, useRef, useState } from 'react';
import { calculateVisibleItems } from "./utils";

// eslint-disable-next-line @typescript-eslint/no-implied-eval
var calcValue = function calcValue(fn) {
  return new Function("return ".concat(fn))();
};
export var useVisibleItems = function useVisibleItems(items, size, visibleCount) {
  var length = items.length;
  var parentRef = useRef(null);
  var parentSize = useComponentSize(parentRef).width;
  var _useState = useState(items),
    _useState2 = _slicedToArray(_useState, 2),
    visibleItems = _useState2[0],
    setVisibleItems = _useState2[1];
  var getVisibleItems = function getVisibleItems() {
    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (!visibleCount) {
      return items;
    }
    return visibleCount === 'auto' ? calculateVisibleItems(items, size, parentSize, offset) : _toConsumableArray(items).slice(0, Math.max(visibleCount - 1, 0));
  };
  useEffect(function () {
    if (visibleCount === 'auto') {
      setTimeout(function () {
        var calculatedOffset = parentRef.current ? calcValue(window.getComputedStyle(parentRef.current).getPropertyValue('--avatar-group-gap').replace(/(calc\(|px|\))/gi, '')) : 0;
        setVisibleItems(getVisibleItems(calculatedOffset));
      }, 0);
    } else {
      setVisibleItems(getVisibleItems());
    }
  }, [items, size, parentSize, visibleCount]);
  var hiddenCount = useMemo(function () {
    return length - visibleItems.length;
  }, [visibleItems, length]);
  return {
    visibleItems: visibleItems,
    hiddenCount: hiddenCount,
    parentRef: parentRef
  };
};